// extracted by mini-css-extract-plugin
export default {"container":"ModalWrapper_container__sB4jG"};